<div class="layout-hbox" style="gap: 10px">
    <fluent-button (click)="onShowAlert()">Show Alert</fluent-button>
    <fluent-button (click)="onShowError()">Show Error</fluent-button>
    <fluent-button (click)="onShowYesNo()">Show Yes/no</fluent-button>
    <fluent-button (click)="onShareLink()">Share Link</fluent-button>
    <fluent-button (click)="onShowPrompt()">Prompt</fluent-button>
    <fluent-button (click)="onShowProgress()">Progress</fluent-button>
</div>
